import { useQuery } from "@tanstack/react-query";
import knowledgeDocumentsService from "services/admin/KnowledgeDocumentsService";

export const useGetKnowledgeDocuments = (queryParams = {}) => {
    return useQuery({
        queryKey: ['knowledge-documents', queryParams],
        queryFn: async () => {
            const { data } = await knowledgeDocumentsService.getAll(queryParams)
            return data
        },
        select: (data) => data.rows,
        refetchOnWindowFocus: false,
    })
}